import React from "react";
import DrawerHeader from "@/components/DrawerHeader";
import FullScreenDrawer from "@/components/FullScreenDrawer";
import theme from "@/theme";
import { useMediaQuery } from "@mui/material";
import { DrawerPageProps } from "./types";

export type DrawerPageRenderer = (props: DrawerPageProps) => React.ReactNode;

export type Page = { kind: "select-bundle" } | { kind: "confirm-bundle" };

export type BundleDrawerPageProps = DrawerPageProps & {
  page: Page;
};

export type BundleDrawerProps = DrawerPageProps & {
  contents?: DrawerPageRenderer;
  open?: boolean;
  transparentBackdrop?: boolean;
  title?: string;
};

export const BundleDrawer = ({
  contents,
  open,
  onExit: origExit,
  onBack,
  goToFirstPage: originalGoToFirstPage,
  transparentBackdrop = false,
  title = "",
}: BundleDrawerProps) => {
  const fullScreen: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.sm)
  );

  const onExit = () => {
    onBack?.();
    origExit();
  };

  const goToFirstPage = () => {
    onBack?.();
    originalGoToFirstPage();
  };

  return (
    <FullScreenDrawer
      anchor="right"
      open={open}
      onClose={onExit}
      fullscreen={fullScreen ? "true" : undefined}
      role="dialog"
      aria-modal={true}
      aria-label={title ?? "Select your bundle"}
      BackdropProps={transparentBackdrop ? { className: "bg-transparent" } : {}}
    >
      <DrawerHeader
        sticky={true}
        handleClose={onExit}
        handleBack={onBack}
        text={title ?? "Select your bundle"}
      />
      <div className="grow">
        <div className="relative flex h-full flex-col">
          {contents?.({ onExit, onBack, goToFirstPage }) ?? null}
        </div>
      </div>
    </FullScreenDrawer>
  );
};
